import { render, staticRenderFns } from "./MiniKaskoAddressForm.vue?vue&type=template&id=6024c100&scoped=true&"
import script from "./MiniKaskoAddressForm.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoAddressForm.vue?vue&type=style&index=0&id=6024c100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024c100",
  null
  
)

export default component.exports